import React from "react";
import { Link } from "react-router-dom";

import { Button, Grid, Stack, Typography } from "@mui/material";

import { UserAddOutlined } from "@ant-design/icons";

import { AnimateButton, AuthWrapper } from "@ezhou/app_mantis_1_1";

const Register = () => {
  return (
    <AuthWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="baseline"
            sx={{ mb: { xs: -0.5, sm: 0.5 } }}
          >
            <Typography variant="h3">Sign up</Typography>
            <Typography
              component={Link}
              to={"/login"}
              variant="body1"
              sx={{ textDecoration: "none" }}
              color="primary"
            >
              Already have an account?
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          If your organization is our client, please contact your organization's system
          administrator to set up your account. If your organization is not our client yet, please
          contact our sales team at info@art-digit.com to schedule demo and tryouts.
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="center" spacing={2}>
            <Grid item xs={12}>
              <AnimateButton>
                <Button
                  variant="contained"
                  fullWidth
                  startIcon={<UserAddOutlined />}
                  target="_top"
                  rel="noopener noreferrer"
                  href={`mailto:info@art-digit.com`}
                >
                  Contact Us
                </Button>
              </AnimateButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AuthWrapper>
  );
};

export default Register;
